import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=501aa608&scoped=true&"
import script from "./BaseHeader.vue?vue&type=script&lang=js&"
export * from "./BaseHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeader.vue?vue&type=style&index=0&id=501aa608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501aa608",
  null
  
)

export default component.exports